<template>
    <!--    Loading Bar for all API needed connection-->
    <div style="padding-top: 65px;">
        <div class="is-loading-bar" v-bind:class="{'is-loading': $store.state.isTopLoading }">
            <div class="lds-dual-ring"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TopLoadingBar"
}
</script>

<style scoped lang="scss">
//Loading Bar

.lds-dual-ring {
    display: inline-block;
    width: 80px;
    height: 80px;
}

.lds-dual-ring:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #ccc;
    border-color: #ccc transparent #ccc transparent;
    animation: lds-dual-ring 1.2s linear infinite;
}

@keyframes lds-dual-ring {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}

.is-loading-bar {
    background-color: rgba(255, 255, 255, 0.55);
    text-align: center;
    height: 0;
    overflow: hidden;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;

    &.is-loading {
        height: 80px;
    }
}
</style>
